module.exports = __webpack_public_path__ + "img/Group_27921.e0e58501.png";